import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Cómo recibo mi guía?',
  answer: 'Inmediatamente después del pago recibes el enlace de descarga a tu email.'
}, {
  question: '¿Necesito conocimientos previos de nutrición?',
  answer: 'No. La guía está escrita en lenguaje simple y directo para cualquier persona.'
}, {
  question: '¿Funciona si tengo una dieta especial?',
  answer: 'Sí. Los principios son adaptables a diferentes estilos de alimentación.'
}, {
  question: '¿En qué formato viene la guía?',
  answer: 'En formato PDF, compatible con teléfono, tablet y computadora.'
}, {
  question: '¿Hay garantía?',
  answer: 'Sí. Si no estás satisfecha en 7 días, te devolvemos tu dinero.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-wellness-light-sage py-24 px-6" id="faq" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-37">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-wellness-dark mb-4" data-id="element-38">
            Preguntas frecuentes
          </h2>
          <p className="text-lg text-wellness-dark/70" data-id="element-39">
            Resolvemos tus dudas para que des el paso con confianza.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-40">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.4
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-wellness-sage/20" data-id="element-41">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex justify-between items-center text-left focus:outline-none" data-id="element-42">
                <span className="font-bold text-wellness-dark text-lg pr-8" data-id="element-43">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="flex-shrink-0 text-wellness-green" data-id="element-44">
                  <ChevronDown className="w-6 h-6" data-id="element-45" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-46">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-47">
                    <div className="px-6 pb-5 text-wellness-dark/80 text-lg leading-relaxed border-t border-wellness-light-sage pt-4" data-id="element-48">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}